<template>
  <v-dialog
    v-model="visibility"
    fullscreen
    scrollable
    hide-overlay
    persistent
  >
    <v-card dark class="black-85">
      <div class="px-0">
        <v-toolbar card dark>
          <v-btn icon dark
             @click.native="visibility = false"
          >
            <v-icon>keyboard_backspace</v-icon>
          </v-btn>
          <v-toolbar-title class="headline">
            <v-icon
              class="mr-2"
              :color="fileMimeTypeData.color">
              {{fileMimeTypeData.icon}}
            </v-icon>
            {{fileName}}
          </v-toolbar-title>
        </v-toolbar>
        <v-alert
          v-model="error"
          dismissible
          type="error"
        >
          {{errorMsg}}
        </v-alert>
        <div class="preview" v-if="!busy">
          <div v-for="(prev, index) in previewList" :key="index" class="preview__img pb-4 px-4">
            <img :src="prev" alt=""/>
          </div>
        </div>
      </div>
      <div class="preview__loader" v-if="busy">
        <v-progress-circular
          :size="30"
          indeterminate
          color="white"
        ></v-progress-circular>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getError, decodeUri, getMimeTypeData } from '../../../helpers/helpers';
import { preview, authorizePreview } from '../../../repository/files';

export default {
  name: 'preview-dialog',
  data: () => ({
    busy: false,
    errorMsg: null,
    error: null,
    dialogBusy: false,
    authList: [],
    previewList: [],
  }),
  computed: {
    ...mapGetters('files', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'preview';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
    fileName() {
      return this.dialogVisibility.name;
    },
    fileId() {
      return this.dialogVisibility.id;
    },
    fileMime() {
      return this.dialogVisibility.mime;
    },
    fileMimeTypeData() {
      return getMimeTypeData(this.fileMime);
    },
  },
  methods: {
    ...mapActions('files', [
      'setDialogVisbility',
      'saveTags',
    ]),
    cleardData() {
      this.busy = false;
      this.errorMsg = null;
      this.error = null;
      this.dialogBusy = false;
      this.authList = [];
      this.previewList = [];
    },
    setVisbility() {
      this.setDialogVisbility(false);
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
    },
    async getPreviewList() {
      const currentItem = this.previewList.length;
      const maxLength = this.authList.length;
      if (currentItem < maxLength) {
        try {
          let authorizedUrl = await authorizePreview(this.authList[currentItem].url);
          authorizedUrl = decodeUri(authorizedUrl.data.data.url);
          this.previewList.push(authorizedUrl);
          this.getPreviewList();
          this.busy = false;
        } catch (e) {
          this.getError(e);
        }
      } else {
        this.busy = false;
      }
    },
    async getPreviewAuthsUrls() {
      this.busy = true;
      try {
        const list = await preview(this.fileId);
        this.authList = list.data.data.items;
        this.getPreviewList();
      } catch (e) {
        this.getError(e);
      }
    },
  },
  watch: {
    visibility(val) {
      if (val === true) {
        this.cleardData();
        this.getPreviewAuthsUrls();
      }
    },
  },
};
</script>
